import { APP_MALFUNCTION_SETS } from '@ngb-frontend/shared/config'

import { isMalfunction } from '../typeguards/isMalfunction'

import type {
  MalfunctionCode,
  MalfunctionFormValues,
  MalfunctionSets,
} from '@ngb-frontend/shared/types'

export const filterMalfunctionCodes = (codes?: string[]) => {
  return codes?.filter(isMalfunction)
}

export const extractMalfunctionCodes = (
  dict?: MalfunctionFormValues['malfunctions'],
) => {
  return Object.values(dict || {})
    .flat()
    .filter(Boolean) as unknown as MalfunctionCode[]
}

export const groupMalfunctionCodes = (
  malfunctionCodes?: MalfunctionCode[],
): MalfunctionSets | undefined => {
  return malfunctionCodes?.reduce((acc, curr) => {
    const dict = Object.entries(APP_MALFUNCTION_SETS).find(([_, codes]) =>
      codes.includes(curr),
    )

    if (!dict) return acc

    const [group] = dict
    // @ts-ignore
    if (!acc[group]) acc[group] = []
    // @ts-ignore
    acc[group].push(curr)

    return acc
  }, {})
}
